import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";

import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import PortalVue from "portal-vue";

import VueAnalytics from "vue-ua";

import "@babel/polyfill";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@mdi/font/css/materialdesignicons.css";

import { inicializarDB } from "./db_save";

inicializarDB();

Vue.config.productionTip = false;

Vue.use(PortalVue);

Vue.use(VueAnalytics, {
	appName: "C+ Ing",
	appVersion: "2.2",
	trackingId: "UA-33542195-5",
	vueRouter: router,
	trackPage: true
});

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount("#app");
